import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./../../../../context/AuthEgresadosProvider";

import LoginService from "./../../../../services/alumnos/LoginServices";
import PasswordReset from './../../../../services/alumnos/passwordReset';
import egresadosServices from "./../../../../services/alumnos/egresadosServices"

import { REMOVE_TOKEN_EGRESADOS } from './../../../../../../shared/constants';
import { message } from "antd";

const LOGIN_TYPE_GOOGLE = "LOGIN";
const LOGIN_TYPE_EMAIL = "LOGIN_EMAIL";


export function useLogin() {
    const { isAuthenticated, login, error, setError, } = useAuth();


    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    if (isAuthenticated) {
        navigate("/egresados", { replace: true });
    }

    // Ocultar error automáticamente después de 5s
    useEffect(() => {
        if (!error) return;
        const timer = setTimeout(() => setError(null), 5000);
        return () => clearTimeout(timer);
    }, [error]);

    const onLogin = async (type, token) => {
        setLoading(true);
        let response = null;

        if (type === LOGIN_TYPE_GOOGLE) {
            response = await LoginService.loginGoogle(token);
        } else {
            response = await LoginService.loginEgresado(token);
        }

        if (response?.success) {
            await login(response?.data?.access_token);
        } else {
            setError(response?.message);
            REMOVE_TOKEN_EGRESADOS();
        }
        setLoading(false);
    };

    const handleGoogleSignInResponse = async (response) => {
        const token = response?.credential;
        await onLogin(LOGIN_TYPE_GOOGLE, token);
    };

    const handleSingIn = async (values) => {
        await onLogin(LOGIN_TYPE_EMAIL, values);
    }

    const OnValidateEgresadoSirExistence = async (data) => {
        setLoading(true);
        const response = await egresadosServices.validateEgresadoSirExistence(data);
        setLoading(false);
        return response;
    };

    const onRegisterEgresado = async (data) => {
        setLoading(true);
        const response = await egresadosServices.registerEgresado(data);
        setLoading(false);
        if (response.success) {
            message.success(response?.data)
        }
        return response;
    };

    const onRegisterEgresadoMatriculaAntigua = async (values) => {

        setLoading(true);
        const data = { ...values }; // copiamos el objeto para no mutar el original
        delete data.documento_probatorio;

        const form = new FormData();
        form.append('documento_probatorio', values.documento_probatorio[0]?.originFileObj);
        form.append('data', JSON.stringify(data));
        const response = await egresadosServices.registerEgresadoMatriculaAntigua(form);
        setLoading(false);
        if (response.success) {
            message.success(response?.data)
        }
        return response;
    };


    const onForgotPassword = async (data) => {
        setLoading(true);
        const response = await PasswordReset.forgotPasswordEgresado(data);
        if (!response?.success) {
            setError(response?.message);
        } else {
            message.success(response?.data);
        }

        setLoading(false);
        return response.success;
    };

    const onRecoveryPass = async (data) => {
        setLoading(true);
        const response = await PasswordReset.recoveryPassEgresado(data);
        if (!response?.success) {
            setError(response?.message);
        }
        message.success(response?.data);
        navigate("/egresados/", { replace: true });
        setLoading(false);
    };

    const onConfirmAccountEgresado = async (data) => {
        setLoading(true);
        const response = await PasswordReset.confirmAccountEgresado(data);
        if (!response?.success) {
            setError(response?.message);
        } else {
            message.success(response?.data);
        }
        navigate("/egresados/", { replace: true });
        setLoading(false);
    };

    const onResendTokenByConfirmAccount = async (data) => {
        setLoading(true);
        const response = await PasswordReset.onResendTokenByConfirmAccount(data);
        if (!response?.success) {
            setError(response?.message);
        } else {
            message.success(response?.data);
        }
        navigate("/egresados/", { replace: true });
        setLoading(false);
    };

    const onValidateToken = async (token) => {
        setLoading(true);

        const response = await PasswordReset.validateTokenEgresado({ "token": token });
        if (!response?.success) {
            setError(response?.message);
            navigate("/egresados/", { replace: true });
        }
        setLoading(false);
        return response.success;
    };

    return {
        loading,
        error,
        onLogin,
        onForgotPassword,
        onRecoveryPass,
        handleGoogleSignInResponse,
        handleSingIn,
        onValidateToken,
        OnValidateEgresadoSirExistence,
        onRegisterEgresado,
        onConfirmAccountEgresado,
        onResendTokenByConfirmAccount,
        onRegisterEgresadoMatriculaAntigua
    };
}
